<div class="history-container">
  <div class="history-content">
    <div class="stats-overview" *ngIf="previousMatches.length > 0">
      <div class="stat-card">
        <div class="stat-icon win">
          <lucide-icon name="trophy" [size]="20"></lucide-icon>
        </div>
        <div class="stat-info">
          <div class="stat-value">{{ getWinCount() }}</div>
          <div class="stat-label">Wins</div>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon loss">
          <lucide-icon name="trending-up" [size]="20"></lucide-icon>
        </div>
        <div class="stat-info">
          <div class="stat-value">{{ getLossCount() }}</div>
          <div class="stat-label">Losses</div>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon rate">
          <lucide-icon name="target" [size]="20"></lucide-icon>
        </div>
        <div class="stat-info">
          <div class="stat-value">{{ getWinRate() }}%</div>
          <div class="stat-label">Win Rate</div>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon total">
          <lucide-icon name="circle-dot" [size]="20"></lucide-icon>
        </div>
        <div class="stat-info">
          <div class="stat-value">{{ previousMatches.length }}</div>
          <div class="stat-label">Total</div>
        </div>
      </div>
    </div>

    <div class="matches-section">
      <h2 class="section-title">Recent Matches</h2>

      <div
        class="matches-list"
        *ngIf="previousMatches.length > 0; else noMatches"
      >
        <div
          *ngFor="let match of previousMatches; let i = index"
          class="match-card"
          [class.win]="match.result === 'W'"
          [class.loss]="match.result === 'L'"
          [class.expanded]="match.expanded"
        >
          <div class="match-header" (click)="toggleExpand(i, match)">
            <div class="match-info">
              <div class="match-date-time">
                <span class="date"
                  ><lucide-icon name="calendar" [size]="12"></lucide-icon>
                  {{ match.date }}</span
                >
                <span class="time"
                  ><lucide-icon name="clock" [size]="12"></lucide-icon>
                  {{ match.time }}</span
                >
              </div>

              <div class="match-details">
                <div class="court-info">
                  <span class="court"
                    ><lucide-icon name="landmark" [size]="12"></lucide-icon>
                    {{ match.court }}</span
                  >
                  <span class="match-type"
                    ><lucide-icon name="circle-dot" [size]="12"></lucide-icon>
                    {{ match.matchType }}</span
                  >
                </div>
                <div class="score-info">{{ match.score }}</div>
              </div>
            </div>

            <div class="match-result">
              <div
                class="result-badge"
                [class.win]="match.result === 'W'"
                [class.loss]="match.result === 'L'"
              >
                <span class="result-text">{{
                  match.result === "W" ? "WIN" : "LOSS"
                }}</span>
              </div>
              <button class="expand-btn">
                <span class="expand-icon" [class.rotated]="match.expanded"
                  >›</span
                >
              </button>
            </div>
          </div>

          <div class="match-expanded" *ngIf="match.expanded">
            <div class="teams-container">
              <div class="team my-team">
                <div class="team-header">
                  <span class="team-icon"
                    ><lucide-icon name="user" [size]="14"></lucide-icon
                  ></span>
                  <span class="team-title">My Team</span>
                </div>
                <div class="team-players">
                  <div
                    *ngFor="let player of getTeamPlayers(match.myTeam)"
                    class="player"
                  >
                    {{ player }}
                  </div>
                </div>
              </div>

              <div class="vs-divider">
                <span class="vs-text">VS</span>
              </div>

              <div class="team opponent-team">
                <div class="team-header">
                  <span class="team-icon"
                    ><lucide-icon name="users" [size]="14"></lucide-icon
                  ></span>
                  <span class="team-title">Opponents</span>
                </div>
                <div class="team-players">
                  <div
                    *ngFor="let player of getTeamPlayers(match.opponent)"
                    class="player"
                  >
                    {{ player }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ng-template #noMatches>
        <div class="no-matches">
          <div class="no-matches-icon">
            <lucide-icon name="circle-dot" [size]="32"></lucide-icon>
          </div>
          <h3 class="no-matches-title">No matches yet</h3>
          <p class="no-matches-text">
            Start playing to build your match history!
          </p>
        </div>
      </ng-template>
    </div>
  </div>
</div>
